class ResourceTemplate {
	constructor(el) {
		this.el = el;
		this.featuredResourceEl = this.el.querySelector('.resource__featured-resource');
		this.featuredResourceRow = this.el.querySelector('.resource__featured-resource-row');
		this.featuredId = this.featuredResourceRow.dataset.featuredId;
		this.baseUrl = window.location.origin;
		
		this.displayFeatured();
		this.displaySearchIcon();
		
	}

	displaySearchIcon () {
		const almSearch = document.getElementsByClassName('search-icon');
		if (!almSearch.length) return;
		const almSearchButton = almSearch[0].getElementsByTagName('button');
		almSearchButton[0].innerHTML = '<i class="fas fa-search"></i>';
	}
	
	

	displayFeatured = () => {
		window.almComplete = () => {
			const ajaxLoadMoreListing = document.querySelector('.alm-listing');
			const almFilters = ajaxLoadMoreListing.querySelector('.alm-filters');
			const cards = ajaxLoadMoreListing.querySelectorAll('.card');

			if (!almFilters) return;

			if (almFilters.dataset.url === this.baseUrl + '/resources/') {
				this.featuredResourceRow.classList.remove('hidden');
			} else {
				this.featuredResourceRow.classList.add('hidden');
			}
			
			cards.forEach((card) => {
				if (card.dataset.postId === this.featuredId && almFilters.dataset.url === this.baseUrl + '/resources/') {
					card.classList.add('hidden');
				}
			});
		};
	}

	
}

export default ResourceTemplate;
